import { render, staticRenderFns } from "./app-root.vue?vue&type=template&id=5fa63f0e"
import script from "./app-root.vue?vue&type=script&lang=ts"
export * from "./app-root.vue?vue&type=script&lang=ts"
import style0 from "./app-root.vue?vue&type=style&index=0&id=5fa63f0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports